var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-month-statistic-container"},[_vm._m(0),_c('div',{staticClass:"chart-wrapper"},[_c('div',{ref:"chartRef",staticClass:"statisticChart"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"header-line"}),_c('span',{staticClass:"section-title"},[_vm._v("订单近30天数量统计")])])
}]

export { render, staticRenderFns }